import axios from 'axios';
import { createQuery } from 'react-query-kit';

import { appendEscapeParam, encodePathSegment, restUrl } from '@/services/utils';
import { PersistedItem } from '@/types/DataModel';

interface ItemVariables {
    primaryKey__: string;
}

const useItemDetails = createQuery<PersistedItem, ItemVariables>({
    gcTime: 0,
    queryKey: ['itemDetails'],
    fetcher: async ({ primaryKey__ }) => {
        const esc = '~';
        const url = appendEscapeParam(
            restUrl(`items/${encodePathSegment(primaryKey__, esc)}`),
            esc, primaryKey__
        );
        const response = await axios.get(url);
        return response.data;
    }
});

export { useItemDetails };
